import axios from "axios";
import { api } from "./api_route";

export const allTenant = async (values) => {
  try {
    const result = await axios.get(`${api}/tenant/all`);

    return result.data;
  } catch (error) {
    return [];
  }
};

export const createTenant = async (formData) => {
  const response = await axios.post(`${api}/tenants`, formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data.data;
};

export const getTenants = async (userId) => {
  try {
    const response = await axios.get(`${api}/tenants`, {
      params: { userId },
    });

    const body = response?.data;
    // If backend returns an array under `data`, return it
    if (body && Array.isArray(body.data)) return body.data;

    // If backend returns a message like { message: 'No tenants found' }, return empty array
    if (body && typeof body.message === "string") return [];

    // Fallback: if `data` is null/undefined, return empty array
    return body?.data ?? [];
  } catch (error) {
    // Let callers handle errors (createAsyncThunk will catch/reject)
    throw error;
  }
};

export const getTenantById = async (tenantID, userId) => {
  const response = await axios.get(`${api}/tenants/${tenantID}`, {
    params: { userId },
  });
  return response.data.data;
};

export const updateTenant = async (tenantID, formData) => {
  const response = await axios.put(`${api}/tenants/${tenantID}`, formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data.data;
};

export const deleteTenant = async (tenantID, userId) => {
  const response = await axios.delete(`${api}/tenants/${tenantID}`, {
    params: { userId },
  });
  return response.data;
};
